import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const DocumentCsv16Icon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 16 16" fill="currentColor" {...props}>
      <path d="M4.67 8.67c0-.37.3-.67.66-.67h1.34a.67.67 0 1 1 0 1.33H5.33a.67.67 0 0 1-.66-.66Zm.66 2a.67.67 0 0 0 0 1.33h1.34a.67.67 0 1 0 0-1.33H5.33Zm3.34-2c0-.37.3-.67.66-.67h1.34a.67.67 0 1 1 0 1.33H9.33a.67.67 0 0 1-.66-.66Zm.66 2a.67.67 0 0 0 0 1.33h1.34a.67.67 0 1 0 0-1.33H9.33Z" />
      <path
        fillRule="evenodd"
        d="M4 .67a2 2 0 0 0-2 2v10.66a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5a.67.67 0 0 0-.2-.47L10.14.86a.67.67 0 0 0-.47-.2H4ZM8.67 2H4a.67.67 0 0 0-.67.67v10.66A.67.67 0 0 0 4 14h8a.67.67 0 0 0 .67-.67V6H9.33a.67.67 0 0 1-.66-.67V2Zm3.39 2.67H10V2.6l2.06 2.06Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default DocumentCsv16Icon;
